<template>
  <svg :style="style" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="&#230;&#173;&#165;&#233;&#170;&#164;&#230;&#157;&#161;/&#231;&#174;&#173;&#229;&#164;&#180;">
      <g id="Group 3063">
        <g id="Vector">
          <path
            d="M8.63271 10.4324C8.31247 10.8484 7.6851 10.8484 7.36486 10.4324L2.06208 3.54385C1.65712 3.0178 2.03213 2.25586 2.696 2.25586L13.3016 2.25586C13.9654 2.25586 14.3404 3.0178 13.9355 3.54386L8.63271 10.4324Z"
            fill="url(#paint0_linear_3327_88814)" />
          <path
            d="M8.63271 14.4324C8.31247 14.8484 7.6851 14.8484 7.36486 14.4324L2.06208 7.54385C1.65712 7.0178 2.03213 6.25586 2.696 6.25586L13.3016 6.25586C13.9654 6.25586 14.3404 7.0178 13.9355 7.54386L8.63271 14.4324Z"
            fill="url(#paint1_linear_3327_88814)" />
        </g>
      </g>
    </g>
    <defs>
      <linearGradient id="paint0_linear_3327_88814" x1="7.99878" y1="2.25586" x2="7.99878" y2="14.7444"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="white" stop-opacity="0.06" />
        <stop offset="1" stop-color="#5D95FF" stop-opacity="0.57" />
      </linearGradient>
      <linearGradient id="paint1_linear_3327_88814" x1="7.99805" y1="15.2559" x2="7.99805" y2="3.25586"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="white" />
        <stop offset="1" stop-color="#5D95FF" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>

</template>

<script>
export default {
  name: 'arrow-down',
  props: {
    width: {
      type: String,
      default: '16px'
    }
  },
  data() {
    return {
      style: {
        width: this.width,
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
      }
    }
  }
}
</script>